import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import Box from 'components/atoms/Layout/Box/Box';

const StyledAssistant = styled(Box)`
  display: flex;
  flex-direction: column;
  height: 100%;
  
  .Assistant {
    &-toolbar {
      gap: ${props => props.theme.layout('1sp')};
      min-height: ${props => props.theme.layout(61)};
      border-bottom: 1px solid ${props => props.theme.property('palette.divider')};
      &-title {
        flex-grow: 1;
      }
    }
    
    &-content {
      display: flex;
      flex-grow: 1;
      height: 1px;
    }
    
    &-conversation {
      width: 100%;
      height: 100%;
      padding: 0 ${props => props.theme.spacing(3)} ${props => props.theme.spacing(2)} ${props => props.theme.spacing(3)};
      
      .DataList {
        &-list {
          width: 100%;
          overflow-x: hidden;
          padding: ${props => props.theme.spacing(2)} 0;
          overscroll-behavior: contain;
          scroll-margin-top: ${props => props.theme.spacing(2)};
          scroll-margin-bottom: ${props => props.theme.spacing(2)};

          .ListItem {
            &:not(:first-child, :last-child) {
              scroll-margin-top: ${props => props.theme.spacing(1.5)};
              scroll-margin-bottom: ${props => props.theme.spacing(1.5)};
            }
          }
        }
      }

      &-navigation {
        display: flex;
        width: 100%;
        position: relative;
        
        .List {
          width: 100%;
          padding: 0 0 ${props => props.theme.spacing(0.5)} 0;
          overflow-y: scroll;
          
          .ListItem {
            padding: 0;

            .Button {
              text-wrap: nowrap;
            }
          }
        }
      }

      &-form {
        &-wrapper {
          display: flex;
          flex-direction: column;
          gap: ${props => props.theme.layout('1sp')}; 
        }
      }
      
      &-actions {
        display: flex;
        width: 100%;
        justify-content: space-between;

        &-left, &-right {
          display: flex;
          gap: ${props => props.theme.layout('1sp')};

          .Button {
            white-space: nowrap;
          }
        }
      }
    }
  }

  ${props => props.theme.breakpoints.down('lg')} {
    .Assistant {
      &-conversation {
        padding: 0 ${props => props.theme.spacing(2)} ${props => props.theme.spacing(2)} ${props => props.theme.spacing(2)};
      }
    }
  }
  
  ${ComponentStyles}
`;

StyledAssistant.propTypes = {
  theme: PropTypes.object
};

export default StyledAssistant;
